import { initializeApp } from "firebase/app";

const config = {
  apiKey: "AIzaSyBtooq5kszmF27ttInCj7HNHifZrZAYIxM",
  authDomain: "nos2022-8257d.firebaseapp.com",
  projectId: "nos2022-8257d",
  storageBucket: "nos2022-8257d.appspot.com",
  messagingSenderId: "423653966367",
  appId: "1:423653966367:web:a8a13714ed245eb9414b2a"
};

const app = initializeApp(config);

export default app;
